import { jsx as _jsx } from "react/jsx-runtime";
import React, {} from 'react';
import { Alert } from "antd";
import { selectedTenantSelector } from "../../../store/slice/auth";
import { useAppSelector } from "../../../store";
const RequireTenantSelection = ({ children, description = 'Please select a profile', enforce = true }) => {
    const selectedTenant = useAppSelector(selectedTenantSelector);
    if (enforce && !selectedTenant?.id) {
        return (_jsx(Alert, { title: "No Profile Selected", description: description || 'Please select a profile', type: "warning", showIcon: true, className: "fixed-alert" }));
    }
    return (children);
};
export default RequireTenantSelection;
